module.exports = __webpack_public_path__ + "static/media/cocrt.93b4cda4.svg";